import React from "react";
import Navbar from "../components/Navbar";
import {
  Users,
  BarChart2,
  Zap,
  Smartphone,
  Shield,
  Palette,
  Play,
} from "lucide-react";
import Footer from "../components/Footer";
import { Link } from "react-router-dom";

import { useSelector } from "react-redux";
import { selectUserRole } from "../redux/features/auth/authSlice";

const HomePage = () => {
  const userRole = useSelector(selectUserRole);
  const isAdminOrSuper = userRole && ['admin', 'super admin', 'super'].includes(userRole.toLowerCase());
  const features = [
    {
      icon: <Users className="w-8 h-8 text-white" />,
      title: "Live Audience Engagement",
      desc: "Connect with your audience in real-time through polls, Q&A, and interactive elements that keep everyone engaged.",
    },
    {
      icon: <BarChart2 className="w-8 h-8 text-white" />,
      title: "Real-time Analytics",
      desc: "Track engagement metrics, response rates, and audience insights with comprehensive analytics dashboard.",
    },
    {
      icon: <Zap className="w-8 h-8 text-white" />,
      title: "Instant Results",
      desc: "See poll results, quiz scores, and audience feedback instantly as they happen during your presentation.",
    },
    {
      icon: <Smartphone className="w-8 h-8 text-white" />,
      title: "Mobile-First Experience",
      desc: "Audiences can participate using any device - phones, tablets, or computers with seamless cross-platform support.",
    },
    {
      icon: <Shield className="w-8 h-8 text-white" />,
      title: "Secure & Private",
      desc: "Enterprise-grade security ensures your presentations and audience data remain completely private and secure.",
    },
    {
      icon: <Palette className="w-8 h-8 text-white" />,
      title: "Beautiful Templates",
      desc: "Choose from professionally designed templates or create custom presentations that match your brand.",
    },
  ];
  return (
    <div className="min-h-screen bg-lightPurple/5">
      <Navbar />
      <div className="flex items-center justify-center p-4">
        <div>
          <div className="text-center mb-10">
            <h1 className="font-bold text-6xl mt-10">
              Interactive Presentations
            </h1>
            <h1 className="font-bold text-5xl mt-5 text-lightPurple">
              Made Simple
            </h1>
            <p className="text-gray-500 text-2xl mt-8 w-3/4 mx-auto ">
              Create engaging presentations with real-time polls, Q&A, and
              audience participation. Turn passive viewers into active
              participants.
            </p>
            {isAdminOrSuper && (
              <Link to="/creating-presentation">
                <button className="bg-lightPurple text-white px-4 py-2 rounded-lg hover:bg-purpleColor transition my-8 w-60 text-lg">
                  Start Creating
                </button>
              </Link>
            )}
          </div>

          <div className="bg-white rounded-2xl flex items-center justify-center shadow-sm max-w-5xl w-full h-[35rem] relative mx-auto">
            <div className="bg-white rounded-2xl shadow-md p-10 max-w-4xl w-full flex flex-col items-center justify-center h-[30rem] relative mx-auto">
              {/* Play button */}
              <div className="flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-purple-400 flex items-center justify-center cursor-pointer shadow-lg">
                  <Play className="text-white w-8 h-8" />
                </div>
              </div>

              {/* Action button */}
              <button className="mt-4 px-6 py-2 font-bold text-xl text-lightPurple">
                See Orvi Slides in Action
              </button>

              {/* Subtitle */}
              <p className="mt-3 text-gray-600 text-sm text-center">
                Click to watch a 2-minute demo of creating interactive
                presentations
              </p>
            </div>
          </div>

          <div className="my-20">
            <h2 className="font-bold text-3xl text-center py-5">
              Everything you need for engaging presentations
            </h2>
            <h2 className=" text-xl text-gray-500 text-center pb-10">
              Powerful features designed to transform your presentations into
              interactive experiences
            </h2>

            <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 px-6 ">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-sm p-6 flex flex-col hover:shadow-lg"
                >
                  <div className="w-12 h-12 rounded-lg bg-purple-400 flex items-center justify-center shadow-md">
                    {feature.icon}
                  </div>
                  <h3 className="mt-4 font-semibold text-lg text-gray-900">
                    {feature.title}
                  </h3>
                  <p className="mt-2 text-gray-600 text-sm">{feature.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default HomePage;
